const tasksData = [
  {
    title: "Backlog Tasks",
    id:"BACKLOG",
    count: 0,
  },
  {
    title: "To-do Tasks",
    id:"TODO",
    count: 0,
  },
  {
    title: "In-Progress Tasks",
    id:"INP",
    count: 0,
  },
  {
    title: "Completed Tasks",
    id:"COMPLETED",
    count: 0,
  }
];

const prioritysData = [
  {
    title: "Low Priority",
    id: "LP",
    count: 0,
  },
  {
    title: "Moderate Priority",
    id: "MP",
    count: 0,
  },
  {
    title: "High Priority",
    id: "HP",
    count: 0,
  },
  {
    title: "Due Date Tasks",
    id:"DD",
    count: 0,
  }
];

export { prioritysData , tasksData };
